import React from "react";
import { NavLink } from "react-router-dom";

import styled from "styled-components";
import Dropdown from "./Dropdown";

export default function Menubar() {
  const menus = [
    { title: "회사소개", link: "/about/message" },
    { title: "제품", link: "/product" },
    { title: "포트폴리오", link: "/portfolio" },
    { title: "고객지원", link: "/support" },
  ];

  const Menubar = styled.nav`
    width: 100%;
    position: relative;

    &:hover > div:nth-child(2) {
      display: flex;
    }

    &:visited > div:nth-child(2) {
      display: none;
    }
  `;

  const MenuContainer = styled.div`
    width: 100%;

    display: flex;
    flex-direction: row;
    justify-content: space-around;

    border-top: 1px solid var(--color-grey);
    border-bottom: 1px solid var(--color-grey);

    & > * {
      all: unset;

      width: 25%;
      padding: 0 15px;

      font-size: var(--font-size-title);
      text-align: center;
      line-height: 50px;

      cursor: pointer;
    }

    & > *:hover {
      background-color: var(--color-blueblack);
      color: white;
    }
  `;

  return (
    <Menubar>
      <MenuContainer>
        {menus.map(({ title, link }, index) => {
          return (
            <NavLink to={link} key={index}>
              {title}
            </NavLink>
          );
        })}
      </MenuContainer>
      <Dropdown />
    </Menubar>
  );
}
